const serviceWorkerRegister = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js').catch((error) => {
            console.log('Service worker registration failed:', error);
        });
    }
};

export default serviceWorkerRegister;
